var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.2917 0h-17.25001c-.76225.00081216-1.49304.302777-2.03203.839637-.538995.536863-.842158 1.264763-.842973 2.024003v12.27276c.000815.7592.303978 1.4871.842973 2.024.53899.5368 1.26978.8388 2.03203.8396h17.25001c.7622-.0008 1.493-.3028 2.032-.8396.539-.5369.8422-1.2648.843-2.024v-12.27276c-.0008-.75924-.304-1.48714-.843-2.024003-.539-.53686-1.2698-.83882484-2.032-.839637zm-.728 4.73676-7.3929 5.72724c-.1441.1117-.3215.1723-.5041.1723s-.36-.0606-.5042-.1723l-7.39282-5.72724c-.08686-.06533-.15982-.14721-.21463-.24087-.05482-.09366-.0904-.19724-.10468-.30472-.01427-.10748-.00697-.21671.02151-.32135.02847-.10464.07753-.2026.14434-.28819s.15004-.15709.24483-.21037c.0948-.05327.19928-.08725.30737-.09996.1081-.01271.21765-.00389.32229.02594s.20229.08007.28727.14782l6.88872 5.33659 6.8887-5.33659c.1722-.12957.3888-.1864.6028-.1582.214.02821.4082.13917.5407.30891.1325.16973.1926.38459.1673.59811s-.134.40854-.3025.54288z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail.4ac736165fc67eb4854a37caf8c72fab.svg";